export const removeItem = (_, payload) => payload.projectList.splice(payload, 1)
